// Status of the "Working on your request" card and the Bootstrap classes
// that colour it. Mixed into BolideAssistantMessages' methods.
export default {
  get_thinking_status(message) {
    const steps = Array.isArray(message?.thinking_steps) ? message.thinking_steps : [];

    if (steps.some((step) => step.status === "failed")) {
      return "failed";
    }

    if (steps.length && steps.every((step) => step.status === "complete")) {
      return "complete";
    }

    return "active";
  },

  // Bootstrap text colour for the status pill
  get_thinking_status_class(message) {
    const status = this.get_thinking_status(message);

    if (status === "failed") return "text-danger";
    if (status === "complete") return "text-success";
    return "text-white-50";
  },

  // Bootstrap background for a step's check circle
  get_thinking_step_class(step) {
    if (step.status === "complete") return "bg-success";
    if (step.status === "failed") return "bg-danger";
    return "bg-white bg-opacity-10";
  },

  get_thinking_status_label(message) {
    const status = this.get_thinking_status(message);

    if (status === "failed") {
      return "Needs attention";
    }

    if (status === "complete") {
      return "Ready";
    }

    const steps = Array.isArray(message?.thinking_steps) ? message.thinking_steps : [];
    const completed_count = steps.filter((step) => step.status === "complete").length;

    return steps.length ? `${completed_count}/${steps.length}` : "Starting";
  },
};
